import { Button, Radio as RadioBase, RadioGroup } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import { Heading } from '@sparemin/blockhead';
import styled from 'styled-components';
import {
  DescriptionStyleProps,
  RadioCardGroupProps,
  RootStyleProps,
} from './types';

export const Root = muiStyled(Button)<RootStyleProps>`
  width: 176px;
  height: 108px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  border: 2px solid;
  border-radius: 24px;
  border-color: ${({ $isChecked, theme }) =>
    $isChecked ? theme.palette.primary.main : theme.palette.grey[500]};
  color: black;

  ${(props) => props.theme.breakpoints.down('md')} {
    width: 100%;
  }

  ${({ $labelPlacement }) =>
    $labelPlacement === 'bottom' &&
    `
      width: 143px;
      flex-grow: 1;
      align-items: center;
      justify-content: center;
      padding: 6px 4px;
      border-radius: 16px;
    `}

  .radio-bottom > span {
    padding: 0;
    padding-bottom: 8px;
  }

  ${({ $renderIndicator, theme }) =>
    !$renderIndicator &&
    `
      background-color: ${theme.palette.grey[100]};
    `}
`;

export const RadioCardGroup = styled(RadioGroup)<RadioCardGroupProps>`
  width: 100%;
  gap: ${({ $gap }) => $gap ?? '14px'};
`;

export const Radio = muiStyled(RadioBase)`
  padding-left: 16px;
`;

export const Description = styled(Heading).attrs({
  level: 3,
})<DescriptionStyleProps>`
  width: 100%;
  margin-top: 6px;
  text-align: center;
  text-transform: none;

  ${(props) => props.theme.breakpoints.down('md')} {
    text-align: start;
    padding-left: 16px;
  }

  ${({ $labelPlacement }) =>
    $labelPlacement === 'bottom' &&
    `
      margin-top: 0;
      font-size: 17px;
    `}
`;
